import template	from "./dialog-news.html";
import css		from "./dialog-news.css";

import Dialog	from "dialog";
import Richbox	from "richbox";


class NewsDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-news", NewsDialog);
  }
  constructor(...args) {
    super(...args);

    this.show(...args);
  }
  buttonClose_click() {
    this.close();
  }
}

NewsDialog.constructor();

export default NewsDialog;